module.exports = __webpack_public_path__ + "img/14-1_08.361b3a87.jpg";